module.exports = __webpack_public_path__ + "img/canada-genitourinary-diseases-male.4869c6bb.png";